﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import queryString from "query-string";
import {loaderShow, loaderHide} from "./loader";
import printThis from "print-this";

export function initShortListOperation() {
    initAddRemoveButtons();
    initClearButton();
}

function initAddRemoveButtons() {
    $("[data-shortlist-operation]").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            let url = $this.data("shortlist-operation");
            let isInShortlist = $this.data("is-in-shortlist");
            let parsed = queryString.parse('');
            if (isInShortlist == true) {
                parsed.operation = "remove";
            } else {
                parsed.operation = "add";
            }
            url = queryString.stringifyUrl({url: url, query: parsed});
            sendShortlistOperation(url, function (data) {
                let holder = $(".shortlist.shortlist-header");
                holder.replaceWith(data);
                updateShortlistBadge();
                
                if (isInShortlist) {
                    $this.data("is-in-shortlist", false);
                    $this.html('<i class="bi bi-suit-heart me-2 fs-4"></i> Save to Shortlist');
                } else {
                    $this.data("is-in-shortlist", true);
                    $this.html('<i class="bi bi-x me-2 fs-4"></i> Remove from Shortlist');
                }
                initClearButton();
            });
        })
    });

    $("[data-print]").each(function () {
        let self = $(this);
        let container = self.data('print');
        self.on("click", function () {
            $(container).printThis();
        });
    });

    $("[data-copy]").each(function () {
        let self = $(this);
        let text = self.data('copy');
        let result = null;
        self.on("click", function () {
            if (!navigator.clipboard) {
                result = fallbackCopyTextToClipboard(text);
            } else {
                navigator.clipboard.writeText(text).then(function () {
                    result = true;
                }, function (err) {
                    result = false
                });
            }

            setTimeout(function () {
                if (result) {
                    let thisLabel = self.text();
                    if (!thisLabel) {
                        thisLabel = "Copied";
                    }
                    self.text(self.data("copied"));
                    setTimeout(function () {
                        self.text(thisLabel);
                    }, 2000);
                }
            }, 100);

        });
    });
}

function initClearButton() {
    $("[data-shortlist-clear]").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            let url = $this.data("shortlist-clear");
            sendShortlistOperation(url, function (data) {
                let holder = $(".shortlist.shortlist-header");
                holder.replaceWith(data);
                updateShortlistBadge();
                $("[data-shortlist-operation]").each(function () {
                    $(this).data("is-in-shortlist", false);
                    $(this).text("Save to Shortlist");
                });
                initClearButton();
            });
        })
    });
}

function sendShortlistOperation(source, callback = function () {
}, waiting = "body") {
    loaderShow(waiting);
    $.ajax({
        url: source, type: 'GET', dataType: 'html', success: function (data) {
            callback(data);
        }, error: function (error) {
            console.error(error);
        }, complete: function (event) {
            loaderHide(waiting);
        }
    });
}

function updateShortlistBadge(){
    let shortlistBadge = $("[data-shortlist-badge]");
    if (shortlistBadge.length > 0) {
        let holder = $(".shortlist.shortlist-header");
        let count = holder.data("shortlist-count");
        shortlistBadge.html(count);
        if (count > 0){
            shortlistBadge.closest(".badge").removeClass("d-none");
        }
        else{
            shortlistBadge.closest(".badge").addClass("d-none");
        }
    }
}